import React from "react";
import { isAfter } from "date-fns";
import PropTypes from "prop-types";
import AtomDek from "components/source/atoms/atom-dek";
import AtomHed from "components/source/atoms/atom-hed";
import AnimatedTextInputWrapper from "components/source/shared/animated-text-input-wrapper";
import classNames from "classnames";
import constants from "rtr-constants";
import MaternityHelper from "helpers/maternity-helper";
import { parseFormDate } from "helpers/date-helpers";

class GridTopFiltersDueDate extends React.Component {
  static propTypes = {
    dekText: PropTypes.string,
    dueDate: PropTypes.string,
    editDueDate: PropTypes.bool,
    hedText: PropTypes.string,
    onClickCancel: PropTypes.func.isRequired,
    onClickOptOut: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,
    userData: PropTypes.object,
  };

  state = {
    hasInvalidorUnchangedDate: true,
    dueDate: this.props.dueDate,
  };

  validateInput(value) {
    if (!value) {
      return true;
    }

    const parsed = parseFormDate(value);

    return isAfter(parsed, new Date());
  }

  onBlurCallback = value => {
    this.setState({
      hasInvalidorUnchangedDate: !this.validateInput(value),
      dueDate: value,
    });
  };

  onChangeCallback = value => {
    this.setState({
      hasInvalidorUnchangedDate: !this.validateInput(value),
      dueDate: value,
    });
  };

  onClickSave = () => {
    const newDueDate = this.state.dueDate;
    this.props.onClickSave(newDueDate);
  };

  renderOptOut() {
    if (this.props.editDueDate && this.props.onClickOptOut) {
      return (
        <button className="maternity-text" onClick={this.props.onClickOptOut}>
          Opt Out
        </button>
      );
    }
  }

  render() {
    const classes = classNames("grid-top-filters-due-date", {
      "maternity-due-date": MaternityHelper.inMaternityExperience(this.props.userData),
    });

    return (
      <div className={classes} data-test-id="grid-top-filters-due-date">
        <AtomHed text={this.props.hedText} />
        <AtomDek text={this.props.dekText} mobileText={this.props.dekText} />
        <div className="grid-top-filters__content">
          <AnimatedTextInputWrapper
            id={"maternityDueDate"}
            name={"MaternityDueDate"}
            type={"tel"}
            label={"Due Date"}
            validateInput={value => this.validateInput(value)}
            validationErrorMsg={constants.clientSideErrorMessages.formValidation.dateInvalidFormat}
            onBlurCallback={this.onBlurCallback}
            onChangeCallback={this.onChangeCallback}
            required={true}
            value={this.props.dueDate}
            maskedInput={true}
            mask={"99 / 99 / 9999"}
            alwaysShowMask={true}
            maskChar={" "}
            helperText={constants.DATE_INPUT_HINT_TEXT}
          />
        </div>
        {this.renderOptOut()}
        <div className="grid-top-filters__buttons">
          <button className="btn-secondary" onClick={this.props.onClickCancel}>
            Back
          </button>
          <button
            className="btn"
            disabled={this.state.hasInvalidorUnchangedDate}
            onClick={this.onClickSave}
            data-test-id="grid-save-due-date">
            Save
          </button>
        </div>
      </div>
    );
  }
}

export default GridTopFiltersDueDate;
